import React from 'react';

const AdminPage = () => {
  return (
    <div className="admin-page" style={{ padding: '20px' }}>
      <h1>Admin Hub</h1>
      <p>Work Queues, Template Manager, and Retention Dashboard will be orchestrated here.</p>
    </div>
  );
};
export default AdminPage;
